import React from "react";
import { DateBox, Validator } from "devextreme-react";
import Moment from "moment";

class DateField extends React.PureComponent {
  render() {
    const setValidationRules = [
      {
        type: "required",
        message: "Este campo es requerido",
      },
    ];

    const {
      label,
      type,
      disabled,
      value,
      onChange,
      id,
      optional,
      required,
      customRules,
      styleRoot,
      defaultValue,
      max: maxDate,
      ...rest
    } = this.props;

    let format = "dd/MM/yyyy HH:mm";
    let placeholder = "día/mes/año";
    const max = maxDate ? maxDate : new Date();
    if (rest.placeholder && rest.placeholder.length > 10) {
      rest.placeholder = Moment(rest.placeholder).format("DD/MM/YYYY")
    }
    if (type === "time") {
      format = "HH:mm";
      placeholder = "";
      max.setHours(23, 30);
    }
    if (type === "date") {
      format = "dd/MM/yyyy";
      placeholder = "día/mes/año";
    }

    if (customRules !== undefined) {
      setValidationRules.push(customRules);
    }
    return (
      <div className="field-newDenuncia" style={{ marginLeft: optional ? 20 : 0, ...styleRoot }}>
        <h3><p>{label}{required ? <span className="label-red-requerido"> *</span> : ""}</p></h3>
        <DateBox
          value={value || defaultValue}
          onValueChanged={onChange}
          id={id}
          disabled={disabled}
          displayFormat={format}
          cancelButtonText="Cancelar"
          applyButtonText="Aceptar"
          max={format ? max : null}
          type={type}
          style={{ width: "100%" }}
          // placeholder={placeholder}
          invalidDateMessage={type === "time" ? "Ingresar formato de hora válida" : "Debes ingresar una fecha válida"}
          // {...rest}
        >
          <Validator
            validationRules={setValidationRules}
          />
        </DateBox>
      </div>
    );
  }
}

export default DateField;
